import React from "react";
import ContractorProjectDescription from "../common/ContractorProjectDescription";
import Icons from "../../../assets/images";
import { API_BASEURL } from "../../../environment";
import { contDetailDrawings } from "../services/contractor";
import { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import NoDataFound from "../../../components/common/NoDataFound";

const DrawingDetails = () => {
    const [projectData, setProjectData] = useState();
    let project_id = useParams();
    let type;

    useEffect(() => {
        contDetailDrawings(project_id,type="detail_drawings",(data) => {
    
          setProjectData(data);
        })
        
      }, [])
    

    return( 
        <>
        <div className='dashboard-inner'>
        
    <ContractorProjectDescription/>
   
    {
        projectData?.length > 0 ?
            <>
                <h1 className="d-card-heading d-card-sub-heading">Drawing Details</h1>
                <ul className="sample-gallery">
                    {projectData?.map((data, inx) => {
                       
                        return (
                            data?.type === "detail_drawings" &&
                            <li key={inx}>
                                <span>
                                    <img src={`${API_BASEURL}/${data?.path}` || (Icons.projectBigImg)} alt='' />
                                </span>
                            </li>
                        )
                    })}
                </ul>
                
            </>
            :
            <h5 className="d-flex align-items-center justify-content-center"><div><NoDataFound/></div></h5>
    }
    
    </div>
    </>
    )
}
export default DrawingDetails;